<template>
    <div>
      
          <v-autocomplete  @change="checkNode" v-model="filterDataTigger" :items="nodelDataList" item-text="name" itemprop="key"
          label="节点搜索"></v-autocomplete>
          <div style="max-height: 300px;overflow: auto;" id="triggerTreeBody">
              <Tree :setting="setting" :nodes="treeData" @onCreated="handleCreated" ref="tree" class="md-tree" />
          </div>

    </div>
</template>
<script>
import Tree from "vue-giant-tree";
import { mapState, mapGetters } from "vuex";
import { allInterfacePage } from "@/api/interface/interface_page";
// let ztreeObj = null;
import { innerAction } from "../../SystemAction";
import { sceneAction } from "../../SceneAction";
import { findTypeListBySceneId } from "@/api/device";
let ztreeObj = {};
let dataMap = {};
let uiPageExtIdMap = {};
const systemInnerAction = innerAction
  .flatMap((item) => item.action_list)
  .map((item) => {
    item.type = "system_inner";
    return item;
  });

const sceneInnerAction = sceneAction
  .flatMap((item) => item.action_list)
  .map((item) => {
    item.type = "system_inner";
    return item;
  });

const defaultActionList = [].concat(systemInnerAction, sceneInnerAction);
const defaultActionMap = defaultActionList.reduce((pre, next) => {
  pre[next.id] = next;
  return pre;
}, {});

const castDataFunc = (pageData = {}, map = {}) => {
  let { cId, children, componentName, props } = pageData;
  let xField = pageData['x-field']
  children = children ?? [];
  let arr = children.map(node => castDataFunc(node, map));

  cId = componentName === 'Root' ? 0 : cId;

  let name;
  if (xField !== undefined && xField.name) {
    name = xField.name;
  } else if (props !== undefined && props.title) {
    name = props.title;
  } else {
    name = componentName;
  }

  if (xField !== undefined && xField.extendedPropertiesId) {
    map[cId] = xField.extendedPropertiesId;
  }

  return {
    id: cId,
    name,
    children: arr
  }
}

export default {
    name: "Trigger",
    props: {
        // uiPageMap: {
        //     type: Object,
        //     default: () => {}
        // },
        tiggerFlag:{
          type: Boolean,
          default:false
        },
        tiggertargetPath:{
          type: String,
          default:""
        }
    },
    components: {
        Tree,
    },
    computed: {
        ...mapGetters(['treeData', 'treeDataMap']),
        ...mapState({
            taskInfo: (state) => state.task.checkTaskInfo,
        }),
    },
    data() {
        return {
            filterDataTigger:"",
            nodelDataList: [],
            appendInfo: [],
            headers: [
                { text: '附加信息', align: 'center', value: 'appendInfo' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            meta: {},
            trigger: "",
            showAttachDialog: false,
            appendForm: {},
            setting: {
                check: {
                    //树是否带复选框或者单选框
                    enable: false,
                },
                data: {
                    simpleData: {
                        //是否使用简单数据模式
                        enable: true,
                        //树节点id，一般是后台数据库主键
                        idKey: "id",
                        //父级id
                        pIdKey: "pid",
                        rootPId: "0",
                    },
                },
                //ztree回调函数
                callback: {
                    //树选择事件
                    onClick: this.treeNodeClick,
                },
            },
            currentPageList: [],
            currentPageInsList: [],
            uiPageTree: []
        };
    },
    watch: {
        meta: {
            deep: true,
            handler: function (val) {
                // this.type = this.meta.type;
                delete this.meta.trigger
                const triggerForm = Object.assign({
                    type: this.meta.type,
                    trigger: this.trigger,
                }, this.meta)
                if (val.pageId) {
                    allInterfacePage({ parentId: val.pageId }).then(res => {
                        this.currentPageInsList = res.data.rows;
                    })
                }
                if (val.pageInsKey) {
                  const insPage = this.currentPageInsList.find(item => item.key === val.pageInsKey)
                  if(insPage){
                    let data = JSON.parse(insPage.pageJSON);
                    this.uiPageTree = [castDataFunc(data, this.uiPageMap)];
                    console.log(this.uiPageTree,'this.uiPageTree===========')
                  }
               
              
                }
                this.$emit("updateTrigger", triggerForm);
            },
        },
        trigger(val) {
            // this.$emit("updateTrigger", {
            //     type: this.meta.type,
            //     trigger: val,
            //     deviceId: this.meta.deviceId,
            //     deviceName: this.meta.deviceName,
            // });
        },
        tiggertargetPath:{
          handler(nv, ov) {
             console.log('filter changed', nv)
           },
            deep: true // 可以深度检测到 obj 对象的属性值的变化
        },
 
    },
    mounted(){
      this.getList()
    },
    methods: {
      getList() {
      // const projectId = this.taskInfo.project;
      const courseId = this.taskInfo.course?this.taskInfo.course:'';
      
      findTypeListBySceneId({
        // sceneId: this.taskInfo.taskEditor,
        // type: "editor",
        courseId,
      }).then((res) => {
        this.list = res.data;

        let extMap = {};
        let uiPageMap = {};

        this.actionMap = res.data.reduce((pre, next) => {
          // 获取类型的动作列表
          pre[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.actions
            : [];
          // 记录类型id
          pre[next.structId] = pre[next.structId].map((item) => {
            item._id = next.deviceTypeInfo._id;
            return item;
          });
          // 拼接默认的系统动作
          pre[next.structId] = pre[next.structId].concat(defaultActionList);

          // 根据结构id记录属性列表
          extMap[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.extended_properties
            : [];
          uiPageMap[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.interface
            : [];
          return pre;
        }, {});
        this.extMap = extMap;
        this.uiPageMap = uiPageMap;

        if (this.form && this.form.structId) {
          this.actionList =
            this.actionMap[this.form.realStructId] ?? defaultActionList;   
        }
   
        res.data.reduce((pre, next) => {
          pre[next.structId] = next;
          return pre;
        }, dataMap);
      });
    },
        // selectUiComponent(e) {
        //     const id = e.join();
        //     this.meta.checkComponentId = id;
        //     this.meta.trigger = this.trigger  
        //     console.log(this.meta,'========')
        //     // this.$emit("updateTrigger", this.meta);
        // },

        // selectUiComponent1(e) {
        //     const id = e.join();
        //     this.meta.checkComponentId = id;
          
        //     // this.$emit("updateTrigger", this.meta);
        // },
        // handleAttachConfirm() {
        //     const arr = this.meta.appendInfo ?? [];
        //     arr.push(this.appendForm);
        //     this.appendInfo.push(this.appendForm);
        //     this.meta.appendInfo = this.appendInfo;
        //     this.showAttachDialog = false;
        //     // this.$emit("updateTrigger", Object.assign({
        //     //     type: this.meta.type,
        //     //     trigger: this.trigger,
        //     // }, this.meta));
        // },
        // showAttachForm() {
        //     this.appendForm = {};
        //     this.showAttachDialog = true;
        // },
        // handleDelete(index) {
        //     this.appendInfo.splice(index, 1);
        //     this.meta.appendInfo = this.appendInfo;
        //     // this.$emit("updateTrigger", Object.assign({
        //     //     type: this.meta.type,
        //     //     trigger: this.trigger,
        //     // }, this.meta));
        // },
        // getData() {
        //     const data = this.meta;
        //     return Object.assign({ trigger: this.trigger }, data)
        // },
        // init(form) {
        //     this.meta = Object.assign({}, form);
        //     this.trigger = form.trigger ?? "";
        //     this.appendInfo = form.appendInfo ?? [];
        //     this.handleNodeAutoFocus()
        // },
        handleCreated(obj) {
            ztreeObj = obj;
            this.handleNodeAutoFocus()
        },
        handleNodeAutoFocus() {
            if (!ztreeObj) return;
            let uuuid = this.meta.deviceId
            if(ztreeObj){
              let nodes = ztreeObj.getNodes()
            console.log('nodes :>> ', nodes);
            if(nodes){
              let setModel = (l, arr = []) => {
                return l.flatMap((v) => {
                    if (v.id === uuuid) {
                        let tId = v.tId

                        ztreeObj.refresh()

                        let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
                        if (nodeList[0]) {
                            let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
                            if (parentList[0]) {
                                ztreeObj.expandNode(parentList[0], true, false, false)
                            }
                        }
                        this.$nextTick(() => {
                            let dom = document.getElementById(tId + '_a')
                            if (dom) {
                                dom.click()
                            }
                        })
                        // ztreeObj.checkNode(v, true);
                    }
                    const useArr = [].concat(arr);
                    useArr.push(v.name)

                    const obj = {
                        key: v.id,
                        name: useArr.join('/'),
                        tId: v.tId
                    }


                    if (v.children && v.children.length !== 0) {
                        return [obj].concat(setModel(v.children, useArr))
                    }
                    return [obj]
                })
            }
            this.nodelDataList = setModel(nodes)
            }

            }
       
 
        },
        treeNodeClick(ztreeObj, treeId, treeNode) {
          // console.log(treeNode)
            const treeNodeMap = this.treeDataMap;
            // console.log(treeNodeMap)
            let node = treeNodeMap[treeNode.id] ?? {};
            this.meta.deviceId = treeNode.id;
            this.meta.deviceName = node.targetPath;
            if(node&&node.targetPath){
               this.filterDataTigger = node.targetPath
              this.$emit('setELementsData',node.targetPath)
             }
            if(this.uiPageMap){
              this.currentPageList = this.uiPageMap[treeNode.id] ?? [];
            //   this.$emit("updateTrigger", Object.assign({
            //     type: this.meta.type,
            //     trigger: this.trigger,
            // }, this.meta));
             return 
            }
            // this.$emit("updateTrigger", Object.assign({
            //     type: this.meta.type,
            //     trigger: this.trigger,
            // }, this.meta))

   
        },
        checkNode(e) {
          if(ztreeObj){
             ztreeObj.expandAll(false)
          }
            const data = this.nodelDataList.find(item => item.name === e);
            const uuuid = data.key;
            ztreeObj.refresh()
           

            let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
            if (nodeList[0]) {
                let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
                if (parentList[0]) {
                    ztreeObj.expandNode(parentList[0], true, false, false)
                }
            }
          
            console.log(this.$refs.treeBody, '看下内容')
       
            this.$emit('setELementsData',e)
            this.$nextTick(() => {
                let dom = document.getElementById(data.tId + '_a')  
                let bodyDom = document.getElementById('triggerTreeBody');
                bodyDom.scrollTop = dom.offsetTop;
                if (dom) {
                    dom.click()
                }
            })
         
        }
    },
};
</script>
